import { render, staticRenderFns } from "./BookTypeMassSlidebar.vue?vue&type=template&id=b1243fc6"
import script from "./BookTypeMassSlidebar.vue?vue&type=script&lang=js"
export * from "./BookTypeMassSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports